import axios from 'axios';
import { API_URL, EXCLUDE_URL } from '../data/constant';
import Alert from '../feature/Alert';
import Helper from '../helper/Helper';

let loadingFunctions = null;

export const setLoadingFunctions = (functions) => {
     loadingFunctions = functions;
};

const startLoading = () => {
     if (loadingFunctions && loadingFunctions.startLoading) {
          loadingFunctions.startLoading();
     }
};

const completeLoading = () => {
     if (loadingFunctions && loadingFunctions.completeLoading) {
          loadingFunctions.completeLoading();
     }
};

const downloadExcel = (filename, endpoint, postData = {}) => {
     startLoading();
     let headers = {};
     let date = Helper.getToday();
     let f = `${filename}-${date}.xlsx`;
     if (!EXCLUDE_URL.includes(endpoint)) {
          headers = { 'token': localStorage.getItem('token'), 'Content-Type': 'application/json' };
     }
     axios({
          url: API_URL + endpoint,
          method: 'POST',
          responseType: 'blob',
          data: postData,
          headers: headers
     }).then((response) => {
          completeLoading();
          if (response.data && typeof response.data === 'object' && 'status' in response.data && 'message' in response.data) {
               if (response.data.status === 2) {
                    Alert.error(response.data.message);
               }
          } else {
               const url = window.URL.createObjectURL(new Blob([response.data]));
               const link = document.createElement('a');
               link.href = url;
               link.setAttribute('download', f);
               document.body.appendChild(link);
               link.click();
          }
     }).catch((error) => {
          completeLoading();
          Alert.failure(error.message);
     });
};


export default downloadExcel;
